export default class CloseablePillController {
  remove() {
    this.close({ solutionKey: this.key });
  }
}



// WEBPACK FOOTER //
// ./src/components/closeable-pill/closeable-pill.controller.js